/**
 * ValidateScheduleDateUseCase
 *
 * Computes min/max schedule dates and validates a selected timestamp.
 * Matches Flutter's schedule date validation logic from content_settings_screen.dart.
 */

import { remoteConfigService } from '@/domain/services/remoteConfig/remoteConfigService';

export interface DateBounds {
  minDate: Date;
  maxDate: Date;
  initialDate: Date;
}

export interface ValidateResult {
  valid: boolean;
}

export class ValidateScheduleDateUseCase {
  getDateBounds(existingSchedule?: number | null): DateBounds {
    const now = Date.now();
    const minDate = new Date(now + remoteConfigService.contentScheduleMinHours * 3600000 + 60000);
    const maxDate = new Date(now + remoteConfigService.contentScheduleMaxHours * 3600000);

    const initialDate =
      existingSchedule != null && existingSchedule >= minDate.getTime()
        ? new Date(existingSchedule)
        : minDate;

    return { minDate, maxDate, initialDate };
  }

  validate(timestamp: number): ValidateResult {
    const { minDate, maxDate } = this.getDateBounds();
    const valid = timestamp >= minDate.getTime() && timestamp <= maxDate.getTime();
    return { valid };
  }
}

export const createValidateScheduleDateUseCase = () => new ValidateScheduleDateUseCase();
